// src/components/table/TableCanvas.jsx
import { useSelector, useDispatch } from "react-redux";
import DraggAbleComponentEdit from "./DraggAbleComponentEdit";
import DraggAbleComponentView from "./DraggAbleComponentView";
import { setTables } from "@/redux/slice/table-slice/table-slice";
import { useState } from "react";

export default function TableCanvas({ setSelectedTableSizeUpdate, isItemEdit, setIsItemEdit }) {
  const [selectedIdForCanvasEdit, setSelectedIdForCanvasEdit] = useState(null)
  const { tables } = useSelector((state) => state.table.table);
  const dispatch = useDispatch();

  function setTableStyle(id, css) {
    // read from localStorage (fallback to current redux state)
    let tableList = JSON.parse(localStorage.getItem("tableList")) || tables || [];

    const updatedList = tableList.map((table) => {
      if (table.table_size?.id === id) {
        // update selectedTableSizeUpdate for the sidebar save button
        setSelectedTableSizeUpdate({
          ...table,
          table_size: {
            ...table.table_size,
            style: {
              ...table.table_size.style,
              ...css,
            },
          },
        });

        return {
          ...table,
          table_size: {
            ...table.table_size,
            style: {
              ...table.table_size.style,
              ...css,
            },
          },
        };
      }
      return table;
    });

    // persist both to localStorage and redux store so UI updates everywhere
    localStorage.setItem("tableList", JSON.stringify(updatedList));
    dispatch(setTables(updatedList));
  }

  return (
    <>
      <div className="grid grid-cols-3 gap-6 mt-6">
        {tables.map((data, index) => {
          return isItemEdit ? (
            <DraggAbleComponentEdit
              key={index}
              data={data.table_size}
              fullDetails={data}
              setTableStyle={setTableStyle}
              selectedIdForCanvasEdit={selectedIdForCanvasEdit}
            />
          ) : (
            <div
              key={index}
              onClick={()=>{setIsItemEdit(true); setSelectedIdForCanvasEdit(data)}}
            >
              <DraggAbleComponentView data={data.table_size} fullDetails={data}/>
            </div>
          );
        })}
      </div>
    </>
  );
}
